var map = {
	"./alarm.mp3": [
		110
	],
	"./lamansys.png": [
		228,
		4
	],
	"./pba_footer.png": [
		229,
		5
	],
	"./pba_logo.png": [
		230,
		6
	],
	"./sanatorio.png": [
		231,
		7
	],
	"./sanatorioLogo.png": [
		232,
		8
	],
	"./sanatorio_footer.png": [
		233,
		9
	],
	"./sanatorio_footer2.png": [
		234,
		10
	],
	"./sanatorio_logo.png": [
		235,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 172;
module.exports = webpackAsyncContext;